export function getVariantSellerId(
  offer: App.MerchandiseOffer,
  variant: App.MerchandiseOfferVariant,
): string {
  return variant.sellerId ?? offer.seller.id
}
